import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import './change-password.scss';

function ChangePasswordFooter({
    onSubmit,
    isSubmit = true,
}) {
    return (
        <Fragment>
            <button className='button button--primary auto-mt-md'
                onClick={onSubmit}
                type={ isSubmit ? 'submit' : 'button'} >
                <span className='button-content button-content--icon'>
                    <span>{formMessageConstants.changePassword}</span>
                    <svg
                        className='icon button__arrow-right'
                        width='14'
                        height='12'
                        focusable='false'
                    >
                        <use xlinkHref='#icon-arrow-right'></use>
                    </svg>
                </span>
            </button>
        </Fragment>
    );
}

ChangePasswordFooter.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default ChangePasswordFooter;
